const welcome_banners_es = require('./welcome_banners.json')
export default welcome_banners_es